export default __webpack_public_path__ + "static/media/bechangemaker.40d846df.png";